"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewModel = void 0;
function ViewModel(props, element) {
    const { groupped, columns, search, sortBy, asc, onSort, onSearch, cellComponentName, items } = props;
    console.log({ props });
    return {
        groupped,
        columns,
        onSort,
        onSearch,
        cellComponentName,
        items,
    };
}
exports.ViewModel = ViewModel;
